import GoToAppOrStore from '@/components/GoToAppOrStore';
import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { useGet } from '@/hooks/useGet';
import { analyticsService, LMSEvents } from '@/services/AnalyticsService';
import { redirectToStore } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { ProgramClassStudentView } from '@/store/program/types';
import React, { useEffect } from 'react';
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

const EnrolledCourse: React.FC = () => {
    const history = useHistory();
    const { classId } = useParams<{ classId: string }>();
    const person = useSelector((state: ApplicationState) => state.identity.data.person);

    const getKey = () => {
        if (!classId || !person) {
            return null;
        }

        return `${Constants.PROGRAM_CLASS_STUDENT_VIEW_URI.replace('%p', String(person.id)).replace('%c', classId)}`;
    };

    const { data, loading } = useGet<ProgramClassStudentView>(getKey());

    useEffect(() => {
        analyticsService.logEvent(LMSEvents.ACCESS_COURSE_BY_EMAIL);
    }, []);

    useEffect(() => {
        if (isMobileOnly && (isAndroid || isIOS)) {
            isAndroid && setTimeout(() => redirectToStore(isIOS), 2000);
            window.location.href = Constants.mobileApp.APP_LMS_DEEP_LINK + classId;
        } else {
            if (data) {
                const { classEnrollment, courseStudentViews } = data;

                if (courseStudentViews.length > 1) {
                    // Trilha
                    history.replace(`/lms/enrollments/${classEnrollment.id}/programs/${courseStudentViews[0].programClass.program.id}`);
                } else {
                    const courseId = courseStudentViews[0].course.id;
                    history.replace(`/lms/enrollments/${classEnrollment.id}/courses/${courseId}`);
                }
            }
        }
    }, [data]);

    return loading ? <Loader /> : <GoToAppOrStore />;
};

export default EnrolledCourse;
